import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { HydraCollection } from '../hydra/hydra-collection';
import { SeriesModel } from '../models/course/series.model';

@Injectable({
  providedIn: 'root'
})
export class SeriesApiService extends ApiService {
  readonly resourcePath = 'series';

  list(filters: Record<string, string> = {}): Observable<HydraCollection<SeriesModel>> {
    return this.restList<SeriesModel>(filters);
  }

  get(id: string): Observable<SeriesModel> {
    return this.restRead<SeriesModel>(id);
  }

  getItem(id: string): Observable<SeriesModel> {
    return this.restReadItem<SeriesModel>(id + "/item");
  }

  create(series: object): Observable<SeriesModel> {
    return this.restCreate<SeriesModel>(series);
  }

  update(id: string, series: object): Observable<SeriesModel> {
    return this.restUpdate<SeriesModel>(id, series);
  }
}
